export const firebaseConfig = {
  apiKey: "AIzaSyDd0K67Kz3kZHuGNvpye8ROKLMP-b7To4E",
  authDomain: "lensfolio-f1938.firebaseapp.com",
  projectId: "lensfolio-f1938",
  storageBucket: "lensfolio-f1938.appspot.com",
  messagingSenderId: "907603624803",
  appId: "1:907603624803:web:a67c93db0c36330fc00956",
  measurementId: "G-WHZLCXC0MR",
};
